import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BrowserModule} from '@angular/platform-browser';
import {RouterModule, Routes} from '@angular/router';

import {AdminLayoutComponent} from './layouts/admin-layout/admin-layout.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
    },
    {
        path: '',
        component: AdminLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('./pages/welcome/welcome.module').then(mod => mod.WelcomePageModule)
            },
            {
                path: 'analytics',
                loadChildren: () => import('./pages/analytics/analytics.module').then(mod => mod.AnalyticsPageModule)
            },
            {
                path: 'orders',
                loadChildren: () => import('./pages/orders/orders.module').then(mod => mod.OrdersPageModule)
            },
            {
                path: 'reservations',
                loadChildren: () => import('./pages/reservations/reservation.module').then(mod => mod.ReservationPageModule)
            },
            {
                path: 'administration',
                loadChildren: () => import('./pages/administration/administration.module').then(mod => mod.AdministrationModule)
            },
            {
                path: 'restaurant',
                loadChildren: () => import('./pages/restaurant/restaurant.module').then(mod => mod.RestaurantModule)
            },
            {
                path: 'vouchers',
                loadChildren: () => import('./pages/vouchers/vouchers.module').then(mod => mod.VouchersPageModule)
            },
            {
                path: 'products',
                loadChildren: () => import('./pages/products/products.module').then(mod => mod.ProductsPageModule)
            },
            {
                path: 'attachments',
                loadChildren: () => import('./pages/attachments/attachments.module').then(mod => mod.AttachmentsPageModule)
            },
            {
                path: 'translation',
                loadChildren: () => import('./pages/translation/translation.module').then(mod => mod.TranslationPageModule)
            },
            {
                path: 'logs',
                loadChildren: () => import('./pages/logs/logs.module').then(mod => mod.LogsPageModule)
            },
            {
                path: 'fees',
                loadChildren: () => import('./pages/fees/fees.module').then(mod => mod.FeesPageModule)
            },
            {
                path: 'links',
                loadChildren: () => import('./pages/links/links.module').then(mod => mod.LinksPageModule)
            },
            {
                path: 'diys',
                loadChildren: () => import('./pages/diys/diys.module').then(mod => mod.DiysPageModule)
            },
            {
                path: 'email',
                loadChildren: () => import('./pages/email/email.module').then(mod => mod.EmailPageModule)
            }
        ]
    },
    {
        path: '**',
        redirectTo: 'dashboard'
    }
];

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        RouterModule.forRoot(routes, {
            useHash: true,
            scrollPositionRestoration: 'enabled',
            anchorScrolling: 'enabled',
            scrollOffset: [0, 64]
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
